import { render } from "./UserCheck.vue?vue&type=template&id=fa27be44&scoped=true"
import script from "./UserCheck.vue?vue&type=script&lang=js"
export * from "./UserCheck.vue?vue&type=script&lang=js"

import "./UserCheck.vue?vue&type=style&index=0&id=fa27be44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa27be44"]])

export default __exports__